import { AbstractControl, ValidationErrors } from '@angular/forms';

/** Form-level validator that requires at least one of workTask or note to be provided. Returns { atLeastOneRequired: true } when both workTask is null/undefined AND note is empty/whitespace-only. Returns null when at least one of workTask or note is provided. */
export function atLeastOneRequiredValidator(control: AbstractControl): ValidationErrors | null {
	const workTask = control.get('workTask')?.value;
	const note = control.get('note')?.value?.trim();
	if (!workTask && !note) {
		return { atLeastOneRequired: true };
	}
	return null;
}

/** Form-level validator that returns { sameStartAndEndError: true } when startTime equals endTime. Returns null when startTime and endTime are different. */
export function sameStartAndEndTimeValidator(control: AbstractControl): ValidationErrors | null {
	const useTeamProfile = control.get('useTeamProfile')?.value;
	if (useTeamProfile) {
		return null;
	}
	const startTime = control.get('startTime')?.value;
	const endTime = control.get('endTime')?.value;
	if (startTime && endTime && startTime === endTime) {
		return { sameStartAndEndError: true };
	}
	return null;
}
